module.exports = __webpack_public_path__ + "img/ELMY_80X30.cd439092.png";